'use client';
import React from 'react';

export default function CTASection() {
  return (
    <section
      id="careers"
      className="pb-12 md:pb-16 lg:pb-20 bg-white">

      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* CTA Card — stacked on mobile, side-by-side on md+ */}
        <div
          className="grid grid-cols-1 md:grid-cols-2 overflow-hidden"
          style={{ backgroundColor: '#6dcff6' }}>

          {/* Image */}
          <div className="overflow-hidden" style={{ minHeight: '240px' }}>
            <img
              src="https://img.rocket.new/generatedImages/rocket_gen_img_181738ffc-1767599816757.png"
              alt="Brickwell Housing team members collaborating on community development projects in a modern office"
              style={{
                width: '100%',
                height: '100%',
                minHeight: '240px',
                objectFit: 'cover',
                display: 'block'
              }} />

          </div>

          {/* Content */}
          <div
            className="flex flex-col justify-center"
            style={{
              padding: 'clamp(32px, 5vw, 60px) clamp(24px, 4vw, 50px)'
            }}>

            <h2
              style={{
                fontSize: 'clamp(26px, 3.5vw, 42px)',
                fontWeight: 400,
                color: '#003c82',
                marginBottom: '16px',
                lineHeight: 1.1,
                fontFamily: 'Montserrat, sans-serif'
              }}>

              Come{' '}
              <em style={{ fontStyle: 'italic' }}>build</em>{' '}
              with us.
            </h2>

            <p
              style={{
                fontSize: 'clamp(14px, 1.5vw, 16px)',
                color: '#333333',
                lineHeight: 1.7,
                marginBottom: '24px',
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 400
              }}>

              Brickwell Housing is always looking for dedicated and purpose-driven individuals to join our team as we work together to create exceptional living communities. Join us and help make a real difference in people&apos;s lives!
            </p>

            <div>
              <a
                href="/careers"
                style={{
                  backgroundColor: '#003c82',
                  color: '#ffffff',
                  padding: '12px 28px',
                  fontSize: '14px',
                  fontWeight: '600',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  borderRadius: '2px',
                  fontFamily: 'Montserrat, sans-serif',
                  transition: 'background-color 0.2s ease'
                }}
                onMouseEnter={(e) => {(e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#002a5c';}}
                onMouseLeave={(e) => {(e.currentTarget as HTMLAnchorElement).style.backgroundColor = '#003c82';}}>

                Join Us
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M1 1l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>);

}